/* ==========================================================================
   MG WAVE TICKER
   Moves text (along an SVG textPath) and icons (placed on the path) in a
   continuous loop. Items repeat in block order; enough copies are made to
   fill the whole wave. Supports several instances.
   Options (data attributes on [data-mg-wave]):
     data-mg-wave-duration   seconds for an item to travel the full wave
     data-mg-wave-direction  'right' | 'left'
     data-mg-wave-gap        space between items (SVG units)
   ========================================================================== */
(function () {
  'use strict';

  var mgWaves = new Map();

  function mgInitWave(mgRoot) {
    if (!mgRoot || mgWaves.has(mgRoot)) return;

    var mgPath = mgRoot.querySelector('.mg-wave__path');
    var mgGroup = mgRoot.querySelector('[data-mg-wave-items]');
    if (!mgPath || !mgGroup) return;

    var mgOriginals = Array.prototype.slice.call(mgGroup.querySelectorAll('[data-mg-wave-item]'));
    if (!mgOriginals.length) return;

    var mgDuration = (parseFloat(mgRoot.dataset.mgWaveDuration) || 15) * 1000;
    var mgDir = mgRoot.dataset.mgWaveDirection === 'left' ? -1 : 1;
    var mgGap = parseFloat(mgRoot.dataset.mgWaveGap) || 25;
    var mgReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var mgItems = [];
    var mgSeqLen = 0;
    var mgPathLen = 0;
    var mgRaf = null;
    var mgStart = null;
    var mgVisible = true;

    function mgWidth(mgEl) {
      if (mgEl.dataset.mgWaveItem === 'icon') return parseFloat(mgEl.dataset.mgW) || 0;
      try { return mgEl.getComputedTextLength(); } catch (e) { return 0; }
    }

    function mgBuild() {
      // Remove previous clones
      mgGroup.querySelectorAll('[data-mg-wave-clone]').forEach(function (mgC) { mgC.remove(); });

      mgPathLen = mgPath.getTotalLength();
      var mgBase = [];
      mgSeqLen = 0;
      mgOriginals.forEach(function (mgEl) {
        var mgW = mgWidth(mgEl);
        mgBase.push({ el: mgEl, w: mgW, at: mgSeqLen });
        mgSeqLen += mgW + mgGap;
      });
      if (mgSeqLen <= 0) return;

      var mgCopies = Math.ceil((mgPathLen + mgSeqLen) / mgSeqLen) + 1;
      mgItems = mgBase.slice();
      for (var mgI = 1; mgI < mgCopies; mgI++) {
        mgBase.forEach(function (mgB) {
          var mgClone = mgB.el.cloneNode(true);
          mgClone.setAttribute('data-mg-wave-clone', '');
          mgClone.removeAttribute('data-shopify-editor-block');
          mgGroup.appendChild(mgClone);
          mgItems.push({ el: mgClone, w: mgB.w, at: mgB.at + mgI * mgSeqLen });
        });
      }
      mgItems.forEach(function (mgIt) {
        mgIt.tp = mgIt.el.querySelector('textPath');
      });
    }

    function mgPlace(mgOffset) {
      mgItems.forEach(function (mgIt) {
        var mgPos = mgDir === 1 ? mgIt.at + mgOffset - mgSeqLen : mgIt.at - mgOffset;
        if (mgIt.tp) {
          mgIt.tp.setAttribute('startOffset', mgPos.toFixed(2));
          return;
        }
        var mgCenter = mgPos + mgIt.w / 2;
        if (mgCenter < 0 || mgCenter > mgPathLen) {
          mgIt.el.style.visibility = 'hidden';
          return;
        }
        var mgP = mgPath.getPointAtLength(mgCenter);
        var mgQ = mgPath.getPointAtLength(Math.min(mgPathLen, mgCenter + 1));
        var mgA = Math.atan2(mgQ.y - mgP.y, mgQ.x - mgP.x) * 180 / Math.PI;
        mgIt.el.style.visibility = '';
        mgIt.el.setAttribute('transform', 'translate(' + mgP.x.toFixed(2) + ' ' + mgP.y.toFixed(2) + ') rotate(' + mgA.toFixed(2) + ')');
      });
    }

    function mgTick(mgNow) {
      if (mgStart === null) mgStart = mgNow;
      var mgSpeed = mgPathLen / mgDuration; // units per ms
      var mgOffset = ((mgNow - mgStart) * mgSpeed) % mgSeqLen;
      mgPlace(mgOffset);
      mgRaf = mgVisible ? window.requestAnimationFrame(mgTick) : null;
    }

    function mgRun() {
      if (mgRaf || mgReduce) return;
      mgRaf = window.requestAnimationFrame(mgTick);
    }

    mgBuild();
    mgPlace(0);
    mgRun();

    // Re-measure once web fonts have loaded (text widths change)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        mgBuild();
        mgPlace(0);
      });
    }

    var mgObserver = null;
    if ('IntersectionObserver' in window) {
      mgObserver = new IntersectionObserver(function (mgEntries) {
        mgVisible = mgEntries[0].isIntersecting;
        if (mgVisible) mgRun();
      });
      mgObserver.observe(mgRoot);
    }

    mgWaves.set(mgRoot, {
      destroy: function () {
        if (mgRaf) window.cancelAnimationFrame(mgRaf);
        mgRaf = null;
        mgVisible = false;
        if (mgObserver) mgObserver.disconnect();
      }
    });
  }

  function mgInitAll(mgScope) {
    (mgScope || document).querySelectorAll('[data-mg-wave]').forEach(mgInitWave);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mgInitAll(); });
  } else {
    mgInitAll();
  }

  document.addEventListener('shopify:section:load', function (mgEvent) { mgInitAll(mgEvent.target); });
  document.addEventListener('shopify:section:unload', function (mgEvent) {
    mgEvent.target.querySelectorAll('[data-mg-wave]').forEach(function (mgRoot) {
      var mgW = mgWaves.get(mgRoot);
      if (mgW) { mgW.destroy(); mgWaves.delete(mgRoot); }
    });
  });
})();
